module.exports = __webpack_public_path__ + "img/1.19_Russian_road_sign.222b6022.svg";